namespace Application {
    'use strict';

    export interface IFlexRootScope extends ng.IRootScopeService {
        secondarySidebarActive: boolean;
        alarmConsoleHidden: boolean;
        alarmConsoleSticky: boolean;
        primarySidebarActive: boolean;
        primarySidebarHiding: boolean;
        largeScreen: boolean;
        primarySidebarOpen: boolean;
        primarySidebarClosedByUser: boolean;
        sidebarSecondary: boolean;
        miniSidebarActive: boolean;
        backendConfig: any; // tslint:disable-line:no-any // TODO: When websso is merged, this should be Models.IBackendConfig
        kiosk: boolean;
        langSwitcherModel: string; // TODO: move it to settingsService when necessary
        // placing $rootScope variables inside an object allows to $watch it as 'vars.variableName' (just 'variableName' won't work)
        vars: {
            isUserLoggedIn?: boolean;
            connectionLocked?: boolean;
        };
        versionInfo?: IBuildInfo;
        flexSections: Models.FlexSections;
        previousRoute: Object;
        adminSectionsMode: boolean;
        isMonitoringOnly: boolean;
        isRoleAdmin: boolean;
        isMaintenance: boolean;
        hasSon: boolean;
    }

    flexPortalAppRun.$inject = ['$rootScope',
                                '$location',
                                '$cookies',
                                '$http',
                                '$window',
                                '$timeout',
                                'settingsService',
                                '$q',
                                'navigationHistoryService',
                                'Fullscreen',
                                ];

    export function flexPortalAppRun($rootScope: IFlexRootScope,
                                     $location: ng.ILocationService,
                                     $cookies: ng.cookies.ICookiesService,
                                     $http: ng.IHttpService,
                                     $window: ng.IWindowService,
                                     $timeout: ng.ITimeoutService,
                                     settingsService: Services.SettingsService,
                                     $q: ng.IQService,
                                     navigationHistoryService: Services.NavigationHistoryService,
                                     fBAngular: FBAngular.IFullScreen,): void {

        settingsService.setTheme();

        $http.defaults.headers.post['X-CSRFToken'] = $cookies.get('csrftoken');

        $rootScope.adminSectionsMode = $location.path().indexOf('/admin') !== -1 ? true : false;

        $rootScope.$on('$routeChangeStart', (event: ng.IAngularEvent, next: ng.route.IRoute, prev: ng.route.IRoute) => {

            if (navigationHistoryService.getLastLocation() !== $location.path()) {
                navigationHistoryService.pushLocation($location.path());
            }

            if ($rootScope.flexSections) {
                let originalPath: string = "originalPath";
                let section: Models.IFlexSection;
                if (next[originalPath]) {
                    section = $rootScope.flexSections.getSectionWithPath(next[originalPath]);
                    if (section && !section.canRead) {
                        event.preventDefault();
                        return;
                    }
                }
            }
            if (!($location.url().indexOf('kiosk') > -1)) {
                if ($rootScope.kiosk) {
                    $rootScope.kiosk = false
                }
            }
            else {
                $rootScope.kiosk = true;
            }
            $rootScope.primarySidebarActive = true;

        });

        function exitOnClick(e:any) {
            if (!$rootScope.alarmConsoleHidden) {
                $rootScope.alarmConsoleHidden = true;
                e.stopPropagation();
                return;
            }
            $rootScope.kiosk = false;
            $location.search('kiosk', null);
        }

        $rootScope.$on('$routeChangeSuccess', () => {
            $rootScope.adminSectionsMode = $location.path().indexOf('/admin') !== -1 ? true : false;
            if ($rootScope.flexSections) {
                $('#main_sidebar_sections').css({
                    'min-height':
                        ($rootScope.flexSections.getVisibleSections($rootScope.adminSectionsMode).length + 1) * 45 + "px"
                });
            }

            $("html, body").animate({
                scrollTop: 0,
            }, 200);

            if ($rootScope.kiosk) {
                document.getElementById('page_content').addEventListener("click", exitOnClick
                    , true)
                if ($rootScope.vars.isUserLoggedIn) {
                    $timeout(() => {
                        $rootScope.alarmConsoleHidden = true;
                        $rootScope.primarySidebarActive = false;
                        $rootScope.miniSidebarActive = false;
                        if (!$('body').hasClass('kiosk_body')) {
                            $('body').toggleClass("kiosk_body");
                            $('#page_content').toggleClass("kiosk_page_content");
                            $('.alarms_console_container').toggleClass("kiosk_alarm_console");
                        }
                    }, 0);
                }
            }
            else {
                document.getElementById('page_content').removeEventListener("click", exitOnClick
                    , true);
                if ($('body').hasClass('kiosk_body')) {
                    $('.alarms_console_container').toggleClass("kiosk_alarm_console");
                    $('#page_content').toggleClass("kiosk_page_content");
                    $('body').toggleClass("kiosk_body");
                    $rootScope.primarySidebarActive = true;
                    fBAngular.toggleAll();
                }
            }
            $timeout(() => {
                // $.UIkit.init($('body'));
                if (!$rootScope.alarmConsoleSticky && $('#monitors-container').length === 0)
                    $rootScope.alarmConsoleHidden = true;
                $($window).resize();
            }, 300);
        });

        $rootScope.$on('windowWidth', (event: ng.IAngularEvent, largeScreen: boolean) => {
            $timeout(() => {
                $rootScope.largeScreen = largeScreen; // windowWidth >= 1220 ? true : false;
            });
        });

        $rootScope.$on('windowHeight', (event: ng.IAngularEvent, height: boolean) => {
            $rootScope.adminSectionsMode = $location.path().indexOf('/admin') !== -1 ? true : false;
            $timeout(() => {
                if ($rootScope.flexSections) {
                    $('#main_sidebar_sections').css({ 'min-height' :
                    ($rootScope.flexSections.getVisibleSections($rootScope.adminSectionsMode).length + 1) * 45 + "px"});
                }

            });
        });

        $rootScope.miniSidebarActive = false;
        $rootScope.primarySidebarOpen = ($rootScope.largeScreen) ? true : false;
        $rootScope.primarySidebarClosedByUser = false;
        $rootScope.sidebarSecondary = true;
        $rootScope.alarmConsoleHidden = true;
    }
}